"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Retrieves the correct auth driver for this tenant
 * @param mid - the mid core login
 * @param loginInfo - the login to get a driver for
 * @return the auth driver for this tenant
 * @throws if no auth driver exists for this tenant
 */
exports.default = (mid, loginInfo) => {
    const driver = mid.driverFor(loginInfo.authDriver);
    if (!driver) {
        throw new Error(mid.errors.ERR_MISSING_AUTH_DRIVER(`Missing auth driver "${loginInfo.authDriver}"`));
    }
    else {
        return driver;
    }
};
